import { storageMixin } from 'mixins'

export default {
  mixins: [storageMixin],
  methods: {
    getTheme() {
      return localStorage.getItem('user-theme')
    },
    getMediaPreference() {
      const hasDarkPreference = window.matchMedia(
        '(prefers-color-scheme: dark)'
      ).matches
      if (hasDarkPreference) {
        return 'dark-theme'
      } else {
        return 'light-theme'
      }
    },
    setTheme(theme) {
      localStorage.setItem('user-theme', theme)
      if (this?.$vuetify?.theme) {
        this.$vuetify.theme.dark = theme === 'dark-theme'
      }

      if (document.documentElement.className === theme) {
        return
      }

      this.$_savePropToDBStorage('user-theme', theme)
      document.documentElement.className = theme
    },
    /**
     * TODO: фичи работают не правильно. Поэтому, вяжемся на логин
     */
    readTheme() {
      const initUserTheme = this.getTheme() || this.getMediaPreference()
      this.setTheme(initUserTheme)
    }
  },
  computed: {
    userTheme() {
      return document?.documentElement?.className || 'light-theme'
    },
    curentUser() {
      return this.$store.getters['GET_USER']
    },
  },
}
